"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

require("../styles/_output-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SMALL_BREAKPOINT = 1210;

function OutputDetails(_ref) {
  var outputWidth = _ref.outputWidth,
      aspectRatio = _ref.aspectRatio,
      appliedAddons = _ref.appliedAddons,
      onChangeAddon = _ref.onChangeAddon,
      disabled = _ref.disabled;
  var duration = appliedAddons.DURATION,
      chromaKey = appliedAddons.CHROMA_KEY,
      rushEdit = appliedAddons.RUSH_EDIT;
  var durationValue = duration && duration.value;
  var chromaKeyValue = chromaKey && chromaKey.value;
  var rushEditValue = rushEdit && rushEdit.value;
  return (/*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('output-details', {
        'output-details--small': outputWidth < SMALL_BREAKPOINT
      })
    }, /*#__PURE__*/_react.default.createElement(_commonReact.AspectRatio, {
      onChangeAddon: onChangeAddon,
      aspectRatio: aspectRatio,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(_commonReact.Duration, {
      onChangeAddon: onChangeAddon,
      duration: durationValue,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(_commonReact.ChromaKey, {
      chromaKey: chromaKeyValue,
      onChangeAddon: onChangeAddon,
      disabled: disabled
    }), /*#__PURE__*/_react.default.createElement(_commonReact.RushEdit, {
      rushEdit: rushEditValue,
      onChangeAddon: onChangeAddon,
      disabled: disabled
    }))
  );
}

var _default = (0, _react.memo)(OutputDetails);

exports.default = _default;